import BpkBreakpoint, {
  BREAKPOINTS,
} from '@skyscanner/backpack-web/bpk-component-breakpoint';
import BpkText from '@skyscanner/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import ReviewImageGallery from '../ReviewImageGallery';

import type { ImagesItem } from '@hotels-hotel-detail/ui/types';
import type { MiniEventTracker } from '@shared/types/frontend/mini-event-tracker';
import type { UserContext } from '@shared/types/user-context';

import STYLES from './ReviewImages.module.scss';

import { useReviewImages } from '@hotels-hotel-detail/data-access/hooks/useHotelImagesContext';
import { FormattedMessage } from '@shared/ui/components/i18n';
import { withMiniEventTracker } from '@shared/ui/contexts/mini-events';
import { withUserContext } from '@shared/utils-frontend/contexts/UserContext';
import {
  ACTION_TYPE,
  CLICK_AREA,
} from '@shared/utils-frontend/mini-events/constants';
import { buildAdditionalInfoViewButtonClicked } from '@shared/utils-frontend/mini-events/hotels-action';

type Props = {
  userContext: UserContext;
  useLighterTitle?: boolean;
  miniEventTracker: MiniEventTracker;
};

const cls = cssModules(STYLES);

const ReviewImages = ({
  miniEventTracker,
  useLighterTitle = false,
  userContext,
}: Props) => {
  const reviewImages = useReviewImages();
  if (reviewImages?.length === 0) {
    return null;
  }

  const { enableSEOVariantHotelsDetailsPage } = userContext;

  return (
    <BpkBreakpoint query={BREAKPOINTS.MOBILE}>
      {(isMobile) => (
        <div className={cls('ReviewImages')} data-test-id="all-review-images">
          {(!enableSEOVariantHotelsDetailsPage || isMobile) && (
            <BpkText
              tag="p"
              className={cls(
                'ReviewImages__subTitle',
                useLighterTitle && 'ReviewImages__useLighterTitle',
              )}
            >
              <FormattedMessage label="hotel_review_images" />
            </BpkText>
          )}

          <ReviewImageGallery
            images={reviewImages as ImagesItem[]}
            onClick={() => {
              miniEventTracker.trackHotelsAction(
                ACTION_TYPE.VIEW_BUTTON_CLICKED,
                buildAdditionalInfoViewButtonClicked(
                  CLICK_AREA.REVIEWS_TRAVELLER_IMAGE,
                ),
              );
            }}
            useSmallerImage
            showAllTravellerImages
          />
        </div>
      )}
    </BpkBreakpoint>
  );
};

export default withMiniEventTracker(withUserContext(ReviewImages));
